import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FileText,
  TrendingUp,
  Calendar,
  DollarSign,
  Package,
  Users,
  Building,
  ClipboardList
} from 'lucide-react';

const ReporteDashboard = () => {
  const navigate = useNavigate();


  const reportCards = [
    {
      id: 'entregas-horizontal',
      title: 'Reporte de Entregas (Horizontales)',
      description: 'Historial y estadísticas de entregas realizadas por hospedaje',
      icon: TrendingUp,
      color: 'bg-green-500',
      route: '/reportes/entregas-horizontal',
      available: true
    },
    {
      id: 'entregas-vertical',
      title: 'Reporte de Entregas (Verticales)',
      description: 'Historial y estadísticas de entregas realizadas por edificio',
      icon: TrendingUp,
      color: 'bg-teal-500',
      route: '/reportes/entregas-vertical',
      available: true
    },
    {
      id: 'inventario',
      title: 'Reporte de Inventario',
      description: 'Análisis detallado del inventario de lencería por edificio',
      icon: Package,
      color: 'bg-blue-500',
      route: '/reportes/inventario',
      available: false
    },

    {
      id: 'ocupacion',
      title: 'Reporte de Ocupación',
      description: 'Análisis de ocupación de edificios y tendencias',
      icon: Calendar,
      color: 'bg-purple-500',
      route: '/reportes/ocupacion',
      available: false
    },
    {
      id: 'financiero',
      title: 'Reporte Financiero (optylav)',
      description: 'Interoperabilidad con optylav para obtener el resumen de ingresos, gastos y rentabilidad ',
      icon: DollarSign,
      color: 'bg-yellow-500',
      route: '/reportes/financiero',
      available: false
    },
    {
      id: 'empleados',
      title: 'Reporte de Empleados (optylav)',
      description: 'Interoperabilidad con optylav para obtener desempeño y asistencia del personal',
      icon: Users,
      color: 'bg-pink-500',
      route: '/reportes/empleados',
      available: false
    },
    {
      id: 'propiedades',
      title: 'Reporte de Propiedades',
      description: 'Estado y rendimiento de edificios y hospedajes',
      icon: Building,
      color: 'bg-teal-500',
      route: '/reportes/propiedades',
      available: false
    },
  ];

  const handleCardClick = (report) => {
    if (report.available) {
      navigate(report.route);
    }
  };

  return (
    <div className="p-6">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Dashboard de Reportes
        </h1>
        <p className="text-gray-600">
          Accede a diferentes reportes y análisis del sistema
        </p>
      </div>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {reportCards.map((report) => {
          const Icon = report.icon;
          return (
            <div
              key={report.id}
              onClick={() => handleCardClick(report)}
              className={`
                relative bg-white rounded-lg shadow-md hover:shadow-lg 
                transition-all duration-300 overflow-hidden
                ${report.available ? 'cursor-pointer hover:scale-105' : 'cursor-not-allowed opacity-75'}
              `}
            >
              {/* Color Bar */}
              <div className={`h-2 ${report.color}`} />

              {/* Card Content */}
              <div className="p-6">
                {/* Icon */}
                <div className={`${report.color} w-12 h-12 rounded-lg flex items-center justify-center mb-4`}>
                  <Icon className="w-6 h-6 text-white" />
                </div>

                {/* Title */}
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {report.title}
                </h3>

                {/* Description */}
                <p className="text-sm text-gray-600 mb-4">
                  {report.description}
                </p>

                {/* Status Badge */}
                {!report.available && (
                  <div className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
                    Próximamente
                  </div>
                )}
              </div>

              {/* Hover Effect Overlay */}
              {report.available && (
                <div className="absolute inset-0 bg-gradient-to-t from-black/5 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300" />
              )}
            </div>
          );
        })}
      </div>

      {/* Info Message */}
      <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-start">
          <FileText className="w-5 h-5 text-blue-500 mt-0.5 mr-3 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-900 mb-1">
              Reportes en Desarrollo
            </h4>
            <p className="text-sm text-blue-700">
              Los reportes se irán habilitando progresivamente. Cada reporte incluirá
              filtros avanzados, exportación a Excel/PDF y visualizaciones interactivas.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReporteDashboard;
